import { Factory } from '../interface/factory'
import { v4 as uuidv4 } from 'uuid'
import { I18nString } from './i18nstring'
import { rememberPayload } from '../../_utils/fcdc-v2'

export enum NodeType {
  Site = 'Site',
}

export interface SiteNode {
  type: NodeType.Site
  id: string // site_id
  excludedLockerIds: string[]
}

export class NodeFactory implements Factory<Node> {
  make(json: any): Node {
    return json as Node
  }

  getTableName(): string {
    throw new Error(
      'getTableName() should never be called on a Node. Nodes are not stored in IndexDB.'
    )
  }
}

export class BookingSourceGroup {
  id: string
  names: I18nString[]
  deleted: boolean
  nodes: SiteNode[]
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id || uuidv4()
    this.names = (json.names || []).map((name: any) => new I18nString(name))
    this.deleted = json.deleted || false

    if (json.nodes && Array.isArray(json.nodes)) {
      this.nodes = json.nodes.map((node: any) => {
        if (node.type === NodeType.Site) {
          return {
            type: NodeType.Site,
            id: node.id,
            excludedLockerIds: node.excludedLockerIds || [],
          } as SiteNode
        }
        return node
      })
    } else {
      this.nodes = []
    }

    this.created = json.created ? new Date(json.created) : new Date()
    this.modified = json.modified ? new Date(json.modified) : new Date()
    rememberPayload(this, json)
  }

  static getFactory(): Factory<BookingSourceGroup> {
    return new (class implements Factory<BookingSourceGroup> {
      make(json: any): BookingSourceGroup {
        return new BookingSourceGroup(json)
      }

      getTableName(): string {
        return 'booking_source_groups'
      }
    })()
  }

  static getUrl(bookingSourceGroupId?: string): string {
    return (
      `/booking_source_groups` +
      (bookingSourceGroupId ? '/' + bookingSourceGroupId : '')
    )
  }

  static collectionName = 'booking_source_groups'
}
